/* eslint-disable import/no-anonymous-default-export */
export default {
  "nav.home": "首页",
  "nav.about": "关于我们",
  "nav.services": "服务",
  "nav.creators": "创作者",
  "nav.contact": "联系我们",
  "lang.en": "EN",
  "lang.ko": "KO",
  "lang.zh": "中文",

  "hero.tagline": "小红书营销与直播电商专业机构",
  "hero.title_line1": "在小红书，",
  "hero.title_line2": "成为真正被喜爱的品牌",
  "hero.description": "Dragonfruit专注于帮助韩国品牌进入小红书。从内容策划、K创作者直播电商、店铺运营到中国市场战略，我们全程陪伴，打造让中国消费者真正产生共鸣的品牌。",
  "hero.cta_primary": "免费咨询",
  "hero.cta_secondary": "了解服务",

  "stats.countries": "500+",
  "stats.countries_label": "小红书直播场次",
  "stats.partners": "80+",
  "stats.partners_label": "进入中国市场的品牌",
  "stats.support": "1500万+",
  "stats.support_label": "累计观看人数",
  "stats.global_hub": "98%",
  "stats.global_hub_label": "客户续约率",

  "services.title": "Dragonfruit打造在小红书上真正受欢迎的品牌",
  "services.content_production": "小红书内容营销",
  "services.content_production_desc": "我们创作让中国消费者停下手指、点击收藏的内容。通过算法分析和趋势预测，策划让品牌自然融入小红书生态的故事。",
  "services.live_operations": "小红书直播电商",
  "services.live_operations_desc": "与K创作者的直播不仅仅是卖货。我们策划像朋友推荐一样真实可信的直播场景，用沉浸式的呈现让一场直播成为圈粉的时刻。",
  "services.commerce_support": "小红书店铺运营",
  "services.commerce_support_desc": "从开店、商品上架、订单处理到客服响应和数据报告，我们像经营自己的店铺一样用心管理，打造稳定的销售渠道。",
  "services.shop_management": "K创作者匹配",
  "services.shop_management_desc": "我们不只看数字。我们寻找与品牌价值观真正契合的K创作者，建立长期合作关系，成果永远透明共享。",

  "about.heading": "关于我们",
  "about.company_name": "Dragonfruit",
  "about.section_title": "为什么是Dragonfruit",
  "about.company_desc": "Dragonfruit连接不了解小红书的韩国品牌和不了解韩国的中国消费者。我们不只是代理商，更是与您共同规划增长、承担责任的伙伴。",
  "about.company_desc2": "小红书是超过3亿中国消费者搜索产品、阅读测评、做出购买决策的生活方式平台。但中国市场有不同的文化和算法。Dragonfruit帮助韩国品牌在这里获得关注并被喜爱——通过内容、直播电商、店铺管理和创作者匹配。",
  "about.vision_title": "愿景",
  "about.vision_text": "成为连接韩式美学与中国潮流的最自然桥梁。",
  "about.vision_text2": "我们不只想卖货。我们的目标是建立一种真实的关系：让中国消费者真心喜欢、主动搜索、乐于推荐韩国品牌。这就是为什么我们叫Dragonfruit——我们帮助品牌像火龙果一样独特而令人难忘。",
  "about.mission_title": "使命",
  "about.mission_text": "讲述真实的故事。不伪造数据，不敷衍内容，不追求一次性销量。",
  "about.mission_text2": "我们的工作是在小红书上打造被长期喜爱的品牌。准确洞察中国消费者的需求，结合K创作者的真实魅力创造实际成果，同时每一步都守护品牌的独特性。这就是Dragonfruit的承诺。",
  "about.values_title": "核心价值观",
  "about.values_subtitle": "指导Dragonfruit工作的五项原则。这些原则平等地适用于客户、创作者和我们自己的团队。",
  "about.values.growth": "先理解中国消费者",
  "about.values.growth_desc": "在数据和算法之前，我们深入了解中国消费者需要什么、如何产生共鸣。这是每一项战略的起点。",
  "about.values.creativity": "正确传递韩式感性",
  "about.values.creativity_desc": "我们将韩国品牌独有的感性和故事，用中国消费者自然接受的方式翻译并重新创造。",
  "about.values.mindset": "透明地、一起地",
  "about.values.mindset_desc": "我们公开分享直播销售额、活动数据和店铺表现。建立在信任之上的长期合作关系是我们的骄傲。",
  "about.values.integrity": "不拿内容开玩笑",
  "about.values.integrity_desc": "我们从不制作敷衍的内容。每一件产出都值得收藏、评论、分享给朋友。",
  "about.values.impact": "品牌建设优先于短期销量",
  "about.values.impact_desc": "我们不满足于一场直播的收入。我们相信真正的成功是在小红书上积累帮助品牌持续成长的资产。",

  "contact.heading": "联系我们",
  "contact.subtitle": "准备好开始小红书之旅了吗？告诉我们品牌的现状和目标，我们将一起设计最适合的战略。咨询始终免费。",
  "contact.full_name": "姓名",
  "contact.full_name_placeholder": "请输入姓名",
  "contact.email": "邮箱",
  "contact.email_placeholder": "请输入邮箱",
  "contact.phone": "电话",
  "contact.phone_placeholder": "请输入电话号码",
  "contact.datetime": "咨询时间",
  "contact.service": "您想了解哪项服务？",
  "contact.service_placeholder": "请选择咨询类型",
  "contact.service_content": "内容营销",
  "contact.service_live": "直播电商",
  "contact.service_commerce": "店铺运营",
  "contact.service_creator": "创作者匹配",
  "contact.service_other": "其他",
  "contact.send": "申请免费咨询",
  "contact.success": "咨询已收到！Dragonfruit团队将在24小时内与您联系。",
  "contact.address": "韩国首尔特别市瑞草区南部循环路339街60号 HJ塔402-22, 4楼",
  "contact.postal": "06722, 韩国",
  "contact.website": "https://d-fruit.net/",
  "contact.address_label": "地址",
  "contact.opening_hours": "营业时间",
  "contact.mon": "周一",
  "contact.tue": "周二",
  "contact.wed": "周三",
  "contact.thu": "周四",
  "contact.fri": "周五",
  "contact.hours": "上午10点 - 下午7点",

  "footer.copyright": "© 2025 Dragonfruit. 版权所有。",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",

  "creators.heading": "旗下创作者",
  "creators.subtitle": "与Dragonfruit一起在小红书上活跃的K创作者。他们不只是网红，更是在各自领域拥有真正专业性的伙伴，与中国消费者建立了深厚的信任。",
  "creators.filter_all": "全部",
  "creators.filter_beauty": "美妆",
  "creators.filter_fashion": "时尚",
  "creators.filter_food": "美食",
  "creators.filter_lifestyle": "生活方式",
  "creators.filter_travel": "旅行",
  "creators.followers": "粉丝",
  "creators.instagram": "Instagram",
  "creators.tiktok": "TikTok",
  "creators.xiaohongshu": "小红书",
  "creators.view_profile": "查看主页",
  "creators.join_title": "我们正在寻找一起成长的创作者",
  "creators.join_tagline": "加入我们",
  "creators.join_desc": "你的内容里是否倾注了真正的热情？如果你有与中国消费者沟通的动力，Dragonfruit将与你同行。我们不只是安排直播日程的公司，更是共同规划你长期成长的伙伴。",
  "creators.join_cta": "申请成为创作者",
  "creators.join_name": "姓名",
  "creators.join_name_placeholder": "请输入姓名",
  "creators.join_email": "邮箱",
  "creators.join_email_placeholder": "请输入邮箱",
  "creators.join_phone": "电话",
  "creators.join_phone_placeholder": "请输入电话号码",
  "creators.join_category": "主要内容领域",
  "creators.join_category_placeholder": "请选择领域",
  "creators.join_message": "申请动机及自我介绍",
  "creators.join_message_placeholder": "请自由描述你的内容风格、想在小红书上展示的样子，以及想加入Dragonfruit的原因（最多500字）",
  "creators.join_send": "提交申请",
  "creators.join_success": "申请已收到！审核后我们将单独联系您。",
  "creators.no_results": "该分类下暂无创作者。",

  "nav.brands": "品牌合作",

  "brands.hero.tagline": "以小红书为核心的全球品牌增长伙伴",
  "brands.hero.title_line1": "韩国品牌进军中国市场,",
  "brands.hero.title_line2": "Dragonfruit与您同行",
  "brands.hero.description": "从小红书到TikTok Shop、Shopify、抖音。我们全程陪伴，打造中国消费者真正喜爱的品牌。",
  "brands.hero.cta": "免费咨询",

  "brands.services.title": "品牌服务",
  "brands.services.subtitle": "小红书是主舞台，向全球平台扩展也顺理成章。",
  "brands.services.xiaohongshu.title": "小红书一站式解决方案",
  "brands.services.xiaohongshu.desc": "内容营销、直播电商、店铺运营、K创作者匹配。一个合作伙伴负责您的小红书出海全程。",
  "brands.services.global.title": "全球平台拓展",
  "brands.services.global.desc": "拓展至TikTok Shop、Shopify、抖音等中国及全球平台。以平台优化策略实现销售渠道多元化。",
  "brands.services.analytics.title": "数据驱动绩效管理",
  "brands.services.analytics.desc": "透明共享内容浏览量、直播销售额、店铺转化率等实时数据。确保以成果为中心的体系化运营。",

  "brands.locations.title": "全球网络",
  "brands.locations.heading": "总部设在韩国，为全球主要市场的品牌增长提供支持",
  "brands.locations.subtitle": "总部设在韩国，服务中国、日本、美国、加拿大、中东和欧洲，为每个地区提供本地化策略。",
  "brands.locations.stat_brands": "品牌",
  "brands.locations.stat_creators": "创作者",
  "brands.locations.stat_campaigns": "活动",
  "brands.locations.korea": "韩国 (总部)",
  "brands.locations.korea_desc": "小红书内容策划、K创作者匹配、直播电商战略制定",
  "brands.locations.japan": "日本",
  "brands.locations.japan_desc": "直播电商运营支持、本地化内容制作、日本平台拓展咨询",
  "brands.locations.china": "中国",
  "brands.locations.china_desc": "小红书店铺运营、抖音直播电商、本地合作伙伴网络",
  "brands.locations.usa": "美国",
  "brands.locations.usa_desc": "TikTok Shop入驻支持、Shopify全球店铺运营、本地网红合作",
  "brands.locations.canada": "加拿大",
  "brands.locations.canada_desc": "北美市场定制内容战略、全球电商渠道拓展、多元文化营销",
  "brands.locations.middle_east": "中东",
  "brands.locations.middle_east_desc": "中东美妆时尚趋势分析、本地化内容策划、区域平台适配",
  "brands.locations.europe": "欧洲",
  "brands.locations.europe_desc": "欧洲市场进入战略、全球品牌本地化、跨境电商支持",

  "brands.process.title": "品牌成功的4个阶段",
  "brands.process.step1": "免费咨询",
  "brands.process.step1_desc": "了解品牌的现状和中国市场进入目标",
  "brands.process.step2": "战略制定",
  "brands.process.step2_desc": "设计定制化小红书内容策略和直播路线图",
  "brands.process.step3": "执行与运营",
  "brands.process.step3_desc": "全面管理内容制作、直播和店铺运营",
  "brands.process.step4": "绩效分析",
  "brands.process.step4_desc": "基于数据持续优化和推动增长",

  "brands.cta.title_line1": "您品牌的小红书成功之旅,",
  "brands.cta.title_line2": "现在就开始",
  "brands.cta.desc": "咨询始终免费。让我们一起为您的品牌设计最合适的战略。",
  "brands.cta.button": "申请免费咨询",
}
